import { render, staticRenderFns } from "./modifyPassword.vue?vue&type=template&id=3808df75&"
import script from "./modifyPassword.vue?vue&type=script&lang=js&"
export * from "./modifyPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports